export const AUTHENTICATION_ERROR = 'INVALID_CREDENTIALS';
export const INVALID_ARGUMENTS_ERROR = 'INVALID_ARGUMENTS';
export const UNAUTHORIZED_ERROR = 'UNAUTHORIZED';
